import React, {useState} from 'react';
import Layout, {Content, Footer} from "antd/es/layout/layout";
import {Divider, Col, Modal, Row, Space} from "antd";
import Link from "antd/es/typography/Link";
import {
    Directions,
    selectDirection,
    selectIsTermAgree,
    selectShowModal,
    setMode,
    setShowModal,
    setTermAgree
} from "../features/omikuji/omikujiSlice";
import {QuestionCircleOutlined} from "@ant-design/icons";
import {useAppDispatch, useAppSelector} from "../app/hooks";

export function Layout1_Single(props: any) {
    const dispatch = useAppDispatch()
    const isShowModal = useAppSelector(selectShowModal)
    const isTermAgree = useAppSelector(selectIsTermAgree)
    const direction = useAppSelector(selectDirection)
    const getDirectionText = (direction: Directions) => {
        switch (direction) {
            case "direction1_Kita":
                return "北";
                break;
            case "direction2_Tohoku":
                return "東北";
                break;
            case "direction3_Higashi":
                return "東";
                break;
            case "direction4_Nanto":
                return "南東";
                break;
            case "direction5_Minami":
                return "南";
                break;
            case "direction6_Nansei":
                return "南西";
                break;
            case "direction7_Nishi":
                return "西";
                break;
            case "direction8_Hokusei":
                return "北西";
                break;
            default:
                return "";
        }
    }

    return <>
        <Layout style={{textAlign: "center"}}>
            {/*return <Layout style={{minHeight: "100vh", textAlign: "center"}}>*/}
            <Content>
                <Row style={{marginTop: "24px"}}>
                    {direction &&
                        <Col xs={24}>
                            {getDirectionText(direction)}
                            <Divider/>
                        </Col>
                    }
                    <Col xs={24}>
                        {props.children}
                    </Col>
                </Row>
                <Row>
                    <Col xs={24} style={{paddingBottom: "24px"}}>
                        <Divider/>
                        <Space>
                            <p>
                                AIおみくじ2023&nbsp;
                            </p>
                            <Link onClick={() => dispatch(setShowModal(true))}>
                                <QuestionCircleOutlined/>
                                使い方
                            </Link>
                        </Space>
                    </Col>
                </Row>
                <Modal
                    title="利用規約"
                    open={!isTermAgree}
                    onOk={() => dispatch(setTermAgree(true))}
                    onCancel={() => alert("ご利用には同意が必要です")}
                    cancelText={false}
                    okText="規約に同意して利用する"
                    maskClosable={false}
                    mask={true}
                >
                    <ul>
                        <li>AIおみくじ2023（以下、本サービス）は株式会社Elith（https://elith.co.jp）が提供する人工知能(以下、AIとする）を活用したおみくじサービスです。</li>
                        <li>本サービスはブラウザの録音機能を使用して利用者（以下、ユーザ）から送信される音を元にAIが運勢を判定するものです。</li>
                        <li>本サービスの目的はAIの応用事例を紹介してAIの存在や認知を広めることです。そのため、世に親しまれているおみくじをモチーフとしています。宗教や思想について何ら言及するものでありません。</li>
                        <li>本サービスにおいて表現される「運勢」や「吉」とはユーザの幸運を意味するものではなく、一定の条件の元でAIが算出した値です。</li>
                        <li>本サービスはAIの精度や予測した運勢の正確性を保証するものではありません。</li>
                        <li>ユーザは本規約に同意することで、本規約に記載されている本サービスの提供目的や特性を理解し了承したものとみなされます。</li>
                    </ul>
                    <p>株式会社Elith</p>
                    <p>2023年1月1日 制定</p>
                </Modal>
                <Modal
                    title="使い方"
                    open={isShowModal}
                    onOk={() => dispatch(setShowModal(false))}
                    onCancel={() => dispatch(setShowModal(false))}
                    cancelText={"閉じる"}
                    footer={
                        <p>powered by ELITH Inc. - <a href="https://elith.co.jp" target="_blank">https://elith.co.jp</a></p>
                    }
                >
                    <ul>
                        <li>1) 願い事をする</li>
                        <li>2) ２回手を叩く</li>
                        <li>3) 結果が表示されるよ Tweetしよう！</li>
                    </ul>
                    <Divider />
                    <p>
                        AIおみくじの仕組み
                        <br/>
                        <Link href="https://elith.co.jp/demo/ai-omikuji2023" target="_blank">AIおみくじ2023 技術解説</Link>
                    </p>
                </Modal>
            </Content>
        </Layout>
        {/*<div style={{*/}
        {/*    position: "absolute",*/}
        {/*    display: "float",*/}
        {/*    bottom: "12px",*/}
        {/*    zIndex: "1000",*/}
        {/*    textAlign: "center",*/}
        {/*    width: "100%"*/}
        {/*}}>*/}
        {/*    AIおみくじ2023&nbsp;*/}
        {/*    <Link onClick={() => dispatch(setShowModal(true))}>*/}
        {/*        <QuestionCircleOutlined/>*/}
        {/*    </Link>*/}
        {/*</div>*/}
    </>
}
